import { action as apiAction } from 'api/Api'

type Payload = {
  childId: number
  name: string
  statusId: number
  groupId?: number
  position?: number
  template: any
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { name, childId, statusId, groupId, position, template } = payload

  const args: any = {
    cardId: childId,
    addCard: {
      name: name.trim(),
      statusId,
      template,
    },
  }

  if (statusId && getState()['view-board'].cards[childId]?.statusId === statusId) {
    args.addCard.statusPosition = { above: childId }
  }

  if (groupId) {
    args.groupTarget = {
      groupId,
      position,
    }
  }

  await apiAction('AddNewParentCard', args)
}
